import { STATUS } from '../../utils/constants'
import React from 'react'

export default React.createContext({
  isBlocked: false,
  status: STATUS.idle,
  cancelCall: () => { },
  endCall: () => { },
  makeCall: () => { },
})